import React, { useContext } from 'react';
import { Question } from 'schema/poll';
import { RootContext } from '../../../../contexts/rootContext';
import { useControlsProps } from '../../../../utils/questionPropsHelper';
import { WrapperProps } from '../../../wrapper';
import { Footer } from '../Footer';
import { QuestionWrapperTemplate } from './QuestionWrapperTemplate';

export interface QuestionWrapperProps extends WrapperProps {
  questionType: Question['data']['type'];
}

export const QuestionWrapper: React.FC<QuestionWrapperProps> = props => {
  const { questionType, children } = props;
  const { engine } = useContext(RootContext);

  const hiddenFooter =
    engine.hasTrait(questionType, 'HIDDEN_FOOTER_TYPE') || engine.hasTrait(questionType, 'HIDDEN_QUESTION_TYPE');

  if (hiddenFooter) {
    return children;
  }

  return <QuestionDefaultWrapper {...props}>{children}</QuestionDefaultWrapper>;
};

export const QuestionDefaultWrapper = ({ children, ...props }: QuestionWrapperProps) => {
  const controlProps = useControlsProps(props);

  return (
    <QuestionWrapperTemplate
      {...props}
      footer={controlProps.showFooter && <Footer {...controlProps} alignSurvey={props.alignSurvey} />}
    >
      {children}
    </QuestionWrapperTemplate>
  );
};
